//require('bootstrap/js/src/index');

// Runtime & Application
import $ from "jquery";

require('./bootstrap');
require('./utilities');
require('./cropper');
require('./dropzone.min.js');
require('../../shared/datepicker/auto');
require('../../shared/applicant/step1');
require('../../shared/lightgallery/lightgallery');

/* Image require to one page portfolio*/
require("../../images/logo.png");
require("../../images/mvm_se_logo.png");
// require("../../images/mvmse-logo-black-transparent.png");
require("../../images/mvmse_logo_right_transparent.png");
require("../../images/logo_fehér.png");
require("../../images/first-section-bg.png");
require("../../images/partner_logo_place_holder.png");
require("../../images/home.jpg");

/* Groups images */
require("../../images/szakosztalyok/MVM_asztali_tennis.jpg");
require("../../images/szakosztalyok/MVM_evezes.jpg");
require("../../images/szakosztalyok/MVM_fitness.jpg");
require("../../images/szakosztalyok/MVM_foci.jpg");
require("../../images/szakosztalyok/MVM_futas.jpg");
require("../../images/szakosztalyok/MVM_sieles.jpg");
require("../../images/szakosztalyok/MVM_teke.jpg");
require("../../images/szakosztalyok/MVM_tennis.jpg");
require("../../images/szakosztalyok/MVM_tura.jpg");
require("../../images/szakosztalyok/MVM_vitorlas.jpg");
/* Representation images */
require("../../images/represent-people/cseh_tamas_portfoli.jpg");
// require("../../images/represent-people/fluck_benedek_portfolio.jpg");
require("../../images/represent-people/hamar_edina_portfolio.jpg");
require("../../images/represent-people/kadosa_laszlo_portfolio.jpg");
// require("../../images/represent-people/kecskes_viktor_portfolio_2021.jpg");
require("../../images/represent-people/dr_bozoky_anita.jpg");
require("../../images/represent-people/katona_kolos.jpeg");
require("../../images/represent-people/rabi_veronika.jpg");
require("../../images/represent-people/markus_gyorgy_portfoli.jpg");
require("../../images/represent-people/nagy_arpad_portfolio.jpg");
require("../../images/represent-people/nemeth_gabor_portfolio.jpg");
require("../../images/represent-people/sum_janos_portfolio.jpg");
require("../../images/represent-people/bally_attila.jpg");
require("../../images/represent-people/furchtne_bodrogi_karolina.jpg");
require("../../images/represent-people/hornyak_tamas.jpg");
require("../../images/represent-people/gal_csaba.jpg");
require("../../images/represent-people/empty.png");

require("../../images/user_menu_icon.png");
require("../../images/search_menu_icon.png");
require("../../images/mvmse_logo_bottom_trasparent.png");
require("../../images/mvmse_logo_news_placeholder.png");
require("../../images/icon_date.png");
require("../../images/icon-email.png");
require("../../images/icon-password.png");
require("../../images/icon-password-yellow.png");
require("../../images/custom-competition-header-image_1.jpg");
require("../../images/custom-competition-header-image_2.png");
require("../../images/custom-competition-header-image_3.jpg");
require("../../images/membershipfees-header-image.jpg");
require("../../images/icon-arrow-double-left.png");
require("../../images/icon-arrow-double-right.png");
require("../../images/icon-arrow-left.png");
require("../../images/icon-arrow-right.png");
require("../../images/camp_placeholder_sq.jpg");
require("../../images/camp_placeholder.jpg");

/*  */

// section subpage images
require("../../images/sections/aerobic.jpg");
require("../../images/sections/bicikli.jpg");
require("../../images/sections/evezes.jpg");
require("../../images/sections/foci.jpg");
require("../../images/sections/futo.jpg");
require("../../images/sections/pingpong.jpg");
require("../../images/sections/si.jpg");
require("../../images/sections/teke.jpg");
require("../../images/sections/tenisz.jpg");
require("../../images/sections/termeszetbarat.jpg");
require("../../images/sections/tomegsport_eger.jpg");
require("../../images/sections/tomegsport_gyongyos.jpg");
require("../../images/sections/tomegsport_miskolc.jpg");
require("../../images/sections/vitorlazas.jpg");
require("../../images/sections/uszas.jpg");
require("../../images/sections/horgasz.jpg");
require("../../images/sections/holegballon.jpg");
require("../../images/sections/uszas.jpg");
require("../../images/sections/kosarlabda.jpg");
require("../../images/sections/sakk.jpg");
require("../../images/sections/tollaslabda.jpg");




require("../../images/tagvallatok/bszk.png");
require("../../images/tagvallatok/foldgaztarolo_feher.png");
require("../../images/tagvallatok/foldgazkereskedo.png");
require("../../images/tagvallatok/group.png");
require("../../images/tagvallatok/gter.png");
require("../../images/tagvallatok/net.png");
require("../../images/tagvallatok/partner.png");


require("../../images/custom-competitions/Hero.jpg");
require("../../images/custom-competitions/Rectangle 13.png");
require("../../images/custom-competitions/Rectangle 17.png");
require("../../images/custom-competitions/pdf_icon.png");
require("../../images/custom-competitions/full_size.png");

require('../../images/custom-competitions/flags/1.png');
require('../../images/custom-competitions/flags/2.png');
require('../../images/custom-competitions/flags/3.png');

/*$(function () {

    const $lightGallery = $("#lightgallery");
    if($lightGallery.length){
        //console.log("Lightgallery is here",lightGallery, typeof  lightGallery);
        $lightGallery.lightGallery();
    }

});*/

/* Static competetion images */
require("../../images/custom-competitions/Laser-rajt.jpg");

require("../../images/custom-competitions/mercarius.jpg");
require("../../images/custom-competitions/mvsz_logo.jpg");

require("../../images/custom-competitions/Monautix-Kft.jpg");
require("../../images/custom-competitions/Prize&More_logo.jpg");
require("../../images/custom-competitions/ROOSTER_logo.jpg");


// Svg icon
require("../../images/calendar.svg");

//Hero shapes

require("../../images/poligonleft.png");
require("../../images/poligonright.png");
